// 字号模式，默认为 standard
var EFontSizeMode;
(function (EFontSizeMode) {
    EFontSizeMode["STANDARD"] = "standard";
    EFontSizeMode["MEDIUM"] = "medium";
    EFontSizeMode["LARGE"] = "large";
    EFontSizeMode["X_LARGE"] = "x-large";
})(EFontSizeMode || (EFontSizeMode = {}));

const FONT_STYLE_ID = 'woaFontSizeMode';
// 默认字号
EFontSizeMode.STANDARD;

let styleId = FONT_STYLE_ID;
let sizes = {};
/**
 * @public
 * 初始化
 * @param sizes ISizeTheme
 * @returns
 */
function initSizeTheme(sizes, _styleId) {
    styleId = _styleId || FONT_STYLE_ID;
    addFontSizeModeStyle(sizes);
}
/**
 * @public
 * 设置字号模式
 * @param sizes ISizeTheme
 * @returns
 */
function setSizeTheme(sizes, _styleId) {
    styleId = _styleId || styleId;
    addFontSizeModeStyle(sizes);
}
// 添加样式
function addFontSizeModeStyle(_sizes) {
    if (!_sizes)
        return;
    sizes = _sizes;
    const $style = document.querySelector(`#${styleId}`);
    const cssStr = `:root{${filterStyleStr(JSON.stringify(sizes))}}`;
    if ($style) {
        $style.textContent = cssStr;
    }
    else {
        appendStyle({ id: styleId, cssStr });
    }
}
// 处理成:root的需要的格式
function filterStyleStr(txt) {
    return txt.replace(/\"/gi, '').replace(/\,/gi, ';').replace(/\//gi, ',').replace(/{|}/gi, '').concat(';');
}
// 创建style标签
function appendStyle({ id = '', cssStr }) {
    const styleEl = document.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = id;
    styleEl.textContent = cssStr;
    document.head.appendChild(styleEl);
}
/**
 * @public
 * 通过Key获取对应的尺寸大小
 * @param sizeKey any 因为外层可能传入Enum，所以这里不做限制，在代码逻辑中将非string类型过滤掉
 * @param convertToNum boolean false
 * @param sizePool ISizeTheme 传入的字号池
 * @returns number | string
 */
function getSizeTheme(sizeKey, convertToNum = false, sizePool) {
    if (typeof sizeKey !== 'string')
        return 0;
    sizes = sizePool || sizes;
    const sizeStr = getFontSizeStr({ sizes, sizeKey });
    if (convertToNum) {
        return Number(sizeStr);
    }
    return sizeStr;
}
/**
 * @description 根据对应的字号模式，获取对应的属性的值大小
 * @param0 sizes 字号对象
 * @param1 sizeKey 对应属性名
 * @returns  尺寸大小
 */
function getFontSizeStr({ sizes, sizeKey }) {
    const sizeStr = sizes[sizeKey];
    return sizeStr ? sizeStr.replace('px', '') : '';
}

export { getSizeTheme, initSizeTheme, setSizeTheme };
